module.exports = __webpack_public_path__ + "static/ecarPhoto-a028ef60ed537c44b4283020f33a81e1.png";